import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

export default {
    addFavorite(context, payload) {
        context.commit('addToFavorites', payload)
        Vue.http.post(
            context.getters.authHandler + '/meta', context.state.userData.meta, { headers: context.getters.secureHeaders }
        ).then((r) => {
            let response = r.body
            if (response.result) {
                context.commit('updateUserMeta', response.data)
            } else {
                console.log('response')
            }
        })
    },
    delFavorite(context, payload) {
        context.commit('delFromFavorites', payload)
        Vue.http.post(
            context.getters.authHandler + '/meta', context.state.userData.meta, { headers: context.getters.secureHeaders }
        ).then((r) => {
            let response = r.body
            if (response.result) {
                context.commit('updateUserMeta', response.data)
            } else {
                console.log('response')
            }
        })
    }
}